import { useTranslation } from "react-i18next";
import clsx from "clsx";

import { IconButton } from "../iconButton";

import classes from "./styles.module.scss";

import type { IListBoxHeaderProps } from ".";

import { Icon } from "@/components/atoms/icons";
import { Typography } from "@/components/atoms/typography";
import "ldrs/lineSpinner";

export function ListBoxHeader(props: IListBoxHeaderProps) {
  const {
    title,
    onDownload,
    onPrint,
    iconName: IconName = "List",
    editProps,
    isFetching,
    titlePostfix = "",
  } = props;
  const { t } = useTranslation("form");

  return (
    <div className={clsx([classes.header, "border-bottom"])}>
      <div
        className={clsx(
          "d-flex gap-m1 justify-content-center align-items-center",
          classes.noShrink,
        )}
      >
        <div className={"d-flex"}>
          <Icon
            name={IconName}
            fontWeight={"semi-bold"}
            fontSize={"xl"}
            type={"bold-duotone"}
            color={"primary-main"}
            className={classes.noShrink}
          />
          <Typography
            className={clsx("ps-xs", classes.noShrink)}
            fontFamily={"Morabba"}
            fontWeight={"semi-bold"}
          >
            {`${t(title)} ${titlePostfix}`}
          </Typography>
        </div>
        {isFetching && (
          <l-line-spinner
            size={"17"}
            stroke={"1.7"}
            speed={"1"}
            color={"#161a34"}
          />
        )}
      </div>
      <div className={classes.iconGroup}>
        {onDownload && (
          <IconButton
            icon={<Icon name={"DownloadSquare"} />}
            label={""}
            transparent
            noTooltip
            onClick={onDownload}
          />
        )}
        {onPrint && (
          <IconButton
            icon={<Icon name={"PrinterMinimalistic"} />}
            label={""}
            transparent
            noTooltip
            onClick={onPrint}
          />
        )}
        {editProps && (
          <IconButton
            icon={<Icon name={"PenNewSquare"} />}
            label={t("addAndEdit")}
            transparent
            onClick={editProps.onEdit}
          />
        )}
      </div>
    </div>
  );
}
